import { Stack, Skeleton, Typography, } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  AiInterviewState,
  InPersonState,
  PreScreeningState,
  CandidateState,
  ScreeningState,
} from './constants/constants-nav';
import AiInterviewGroup from './ai-interview-group/index';
import InPersonGroup from './in-person-group';
import PreScreeningGroup from './pre-screening-group';
import ProfileGroup from './profile-group';
import ScreeningGroup from './screening-group';
import { CandidateProfileContext } from './context/candidate-profile-context';

const useStyles = makeStyles(theme => ({
  mainDiv: {
    width: '70%',
    overflow: 'auto',
    // height:"100%"
  },
  navDiv: {
    maxHeight: 60,
    flexDirection: 'row',
    background: theme.palette.background.primaryGrey2,
  },
  navItem: {
    padding: 8,
    justifyContent: 'center',
    alignItems: 'center',
    width: `${100 / navigationItems.length}%`,
    cursor: 'pointer',
  },
  navGroup: {
    padding: '24px 18px 18px 18px',
    height: '100%',
  },
}));

const navigationItems = [
  'Candidate',
  'Pre-screening',
  'Screening',
  'AI interview',
  'Interview',
];

const RightContainer = ({ jobId, navGroup, setNavGroup }) => {
  const classes = useStyles();
  const { candidateType, isLoading } = useContext(CandidateProfileContext);

  return (
    <Stack className={classes.mainDiv}>
      {isLoading ? (
        <Stack direction="row" alignItems="center" width="100%">
          {Array.of(0, 1, 2, 3, 4).map((_, index) => (
            <Stack key={index} width={`${100 / 5}%`}>
              <Skeleton
                variant="rectangular"
                height={40}
                maxHeight={40}
                sx={{
                  backgroundColor: index === 0 && 'white',
                }}
              />
            </Stack>
          ))}
        </Stack>
      ) : (
        candidateType === 'JOB_CANDIDATE' && (
          <Stack className={classes.navDiv}>
            {navigationItems.map((item, index) => (
              <Stack
                sx={{ background: navGroup === item && 'white' }}
                key={index}
                className={classes.navItem}
                onClick={() => setNavGroup(item)}
              >
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                  {item}
                </Typography>
              </Stack>
            ))}
          </Stack>
        )
      )}
      <Stack className={classes.navGroup}>
        {navGroup === CandidateState && <ProfileGroup jobId={jobId} />}
        {navGroup === PreScreeningState && <PreScreeningGroup jobId={jobId} />}
        {navGroup === ScreeningState && <ScreeningGroup />}
        {navGroup === AiInterviewState && <AiInterviewGroup jobId={jobId} />}
        {navGroup === InPersonState && <InPersonGroup jobId={jobId} />}
      </Stack>
    </Stack>
  );
};

export default RightContainer;

RightContainer.propTypes = {
  jobId: PropTypes.string,
  navGroup: PropTypes.string.isRequired,
  setNavGroup: PropTypes.func.isRequired,
};
